document.addEventListener('DOMContentLoaded', function () {
    // 定义自定义元素 yg-more-button
    class YgMoreButton extends HTMLElement {
        constructor() {
            super();
            this.addEventListener('click', this.toggleContent.bind(this));
        }

        toggleContent() {
            const content = this.previousElementSibling;
            if (content) {
                content.classList.toggle('is-open');
                if (content.classList.contains('is-open')) {
                    this.textContent = 'READ LESS';
                } else {
                    this.textContent = 'READ MORE';
                }
            }
        }
    }

    if (!customElements.get('yg-more-button')) {
        customElements.define('yg-more-button', YgMoreButton);
    }

    // const toggleButtons = document.querySelectorAll('.toggle-button');
    // toggleButtons.forEach(button => {
    //     button.addEventListener('click', function () {
    //         this.previousElementSibling.classList.toggle('is-open');
    //         if (this.previousElementSibling.classList.contains('is-open')) {
    //             this.textContent = 'READ LESS';
    //         } else {
    //             this.textContent = 'READ MORE'
    //         }
    //     });
    // });
});